import { render, staticRenderFns } from "./Experiences.vue?vue&type=template&id=5970e76a&scoped=true&"
import script from "./Experiences.vue?vue&type=script&lang=ts&"
export * from "./Experiences.vue?vue&type=script&lang=ts&"
import style0 from "./Experiences.vue?vue&type=style&index=0&id=5970e76a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5970e76a",
  null
  
)

export default component.exports